<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <h2 class="spread-out">
          <span>Share your Reports with your Doctor</span>
          <a
            class="button"
            @click="show_share_modal"
          >Share Now</a>
        </h2>

        <div class="shared-with">
          <div
            v-for="(share,index) in shares"
            class="item"
          >
            <div class="split">
              <div class="side text">
                Shared with <strong>{{ share.name }} ({{ share.email }})</strong>
              </div>
              <div class="side actions">
                <a
                  class="unshare"
                  @click="show_unshare_modal(index)"
                >Unshare</a>
              </div>
            </div>
          </div>
        </div>

        <div class="main-split">
          <div class="main-side">
            <div class="box">
              <h4 class="spread-out">
                <span>Notes</span>
                <span>
                  <a
                    class="button"
                    @click="show_add_note_modal"
                  >Add Note</a>
                </span>
              </h4>
              <div
                v-for="(note,index) in notes"
                v-if="index<5 || !hidenotes"
                class="content-box"
              >
                <div class="title">
                  <span><strong>{{ note.subject }}</strong></span>
                  <span class="date">{{ note.created_date }}</span>
                </div>
                <div class="message">
                  {{ note.message }}
                  <button
                    type="button"
                    class="rem button"
                    @click="remove_note(note.id)"
                  >
                    <i
                      class="fas fa-times"
                      style="margin: 0px;"
                    />
                  </button>
                </div>
              </div>
              <div class="subtitle spread-out">
                <span>{{ notes.length }} Notes Total</span>
                <a
                  v-if="hidenotes && notes.length>5"
                  class="button tertiary"
                  @click="load_more_notes"
                >Load More</a>
              </div>
            </div>
          </div>
          <div class="main-side">
            <div
              v-if="is_free_user"
              class="box"
            >
              <h4>Messages</h4>
              <div class="upgrade-blurb">
                <h6>Unlock with Premium</h6>
                <p>You've found a feature that's only available to Premium users.  The information below is sample data.  You're on the Free plan, which gives you all the basic benefits of FFF without the bells and whistles.  Upgrade to the Premium plan today to unlock more.</p>
                <div class="button-container">
                  <a
                    href="/account/subscriptions"
                    class="button"
                  >Yes Please!</a>
                </div>
              </div>
              <div class="content-box">
                <div class="title">
                  <span><strong>Example Message Header</strong></span> <span class="date" />
                </div> <div class="message">
                  This is where messages sent to you from the FFF team will display. You will receive messages like: "Happy New Years" or "Remember to log your meals and update your Health Assessment as frequently as you can. The more information you put, the more helpful our program can be for you and your health!" and more!
                </div>
              </div>
            </div>
            <div
              v-else
              class="box"
            >
              <h4 class="spread-out">
                <span>Messages</span>
                <span>
                  <!-- <a class="button tertiary" v-on:click="load_more_messages">Load More</a> -->
                </span>
              </h4>
              <div
                v-for="(message,index) in messages"
                v-if="index<5 || !hidemessages"
                class="content-box"
              >
                <div class="title">
                  <span><strong>{{ message.subject }}</strong></span>
                  <span class="date">{{ message.created_date }}</span>
                </div>
                <div class="message">
                  {{ message.message }}
                </div>
              </div>
              <div class="subtitle spread-out">
                <span>{{ messages.length }} Messages Total</span>
                <a
                  v-if="hidemessages && messages.length>5"
                  class="button tertiary"
                  @click="load_more_messages"
                >Load More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Share Modal -->
    <form
      v-show="is_showing_share_modal"
      class="fff-modal share-modal"
      @submit.prevent="submit_share_modal"
    >
      <div
        class="overlay"
        @click="hide_share_modal"
      />
      <div class="box">
        <div
          class="close-modal"
          @click="hide_share_modal"
        >
          &times;
        </div>

        <!-- Fields -->
        <div
          v-show="!share_data.is_success"
          class="field"
        >
          <h4>Share Your Reports</h4>
        </div>
        <div
          v-show="!share_data.is_success"
          class="field horizontal"
        >
          <div><label for="their_name">Their Name *</label></div>
          <div>
            <input
              id="their_name"
              v-model="share_data.name"
              type="text"
              class="fff-ui"
            >
          </div>
        </div>
        <div
          v-show="!share_data.is_success"
          class="field horizontal"
        >
          <div><label for="their_email">Their Email *</label></div>
          <div>
            <input
              id="their_email"
              v-model="share_data.email"
              type="text"
              class="fff-ui"
            >
          </div>
        </div>
        <div
          v-show="!share_data.is_success"
          class="field horizontal"
        >
          <div><label for="message">Message *</label></div>
          <div>
            <textarea
              id="message"
              v-model="share_data.message"
              class="fff-ui"
            />
          </div>
        </div>
        <div
          v-show="!share_data.is_success"
          class="field"
        >
          <button
            type="submit"
            class="button fluid"
          >
            Share
          </button>
        </div>

        <!-- Success -->
        <div
          v-show="share_data.is_success"
          class="field text-center"
        >
          <h2>Submitted</h2>
        </div>
        <div
          v-show="share_data.is_success"
          class="field text-center"
        >
          <p>Awesome, your report has been shared!</p>
        </div>
        <div
          v-show="share_data.is_success"
          class="field text-center"
        >
          <a
            class="button tertiary"
            @click="hide_share_modal"
          >All Done</a>
        </div>
      </div>
    </form>

    <!-- Unshare Modal -->
    <form
      v-show="is_showing_unshare_modal"
      class="fff-modal unshare-modal"
      @submit.prevent="submit_unshare_modal"
    >
      <div
        class="overlay"
        @click="hide_unshare_modal"
      />
      <div class="box">
        <div
          class="close-modal"
          @click="hide_unshare_modal"
        >
          &times;
        </div>
        <div class="field">
          <h4>Are you sure?</h4>
        </div>
        <div class="field">
          Are you sure you want to stop sharing your reports with <strong>{{ unshare_data.email }}</strong>?
        </div>
        <div class="field">
          <button
            type="button"
            class="button tertiary"
            @click="is_showing_unshare_modal = false"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="button"
            @click="submit_unshare_modal"
          >
            Unshare
          </button>
        </div>
      </div>
    </form>

    <!-- Add Note Modal -->
    <form
      v-show="is_showing_add_note_modal"
      class="fff-modal add-note-modal"
      @submit.prevent="submit_add_note_modal"
    >
      <div
        class="overlay"
        @click="hide_add_note_modal"
      />
      <div class="box">
        <div
          class="close-modal"
          @click="hide_add_note_modal"
        >
          &times;
        </div>

        <div class="field">
          <h4>Add a Note</h4>
        </div>

        <div class="field horizontal">
          <div><label for="subject">Subject</label></div>
          <div>
            <input
              id="subject"
              v-model="add_note_data.subject"
              type="text"
              class="fff-ui"
            >
          </div>
        </div>

        <div class="field horizontal">
          <div><label for="note">Note</label></div>
          <div>
            <textarea
              id="note"
              v-model="add_note_data.note"
              class="fff-ui"
            />
          </div>
        </div>

        <div class="field">
          <button
            type="submit"
            class="button fluid"
          >
            Add Note
          </button>
        </div>
      </div>
    </form>

    <!-- Upgrade Modal -->
    <upgrade-modal
      v-show="is_showing_upgrade_modal"
      @show-modal="is_showing_upgrade_modal = true"
      @hide-modal="is_showing_upgrade_modal = false"
    />
  </main>
</template>

<script>
export default {
  name: 'Communications',
  data() {
    return {
      shares: [
        {name: 'one', email: 'one@two.com'},
      ],
      notes: [
        {subject: 'Note 1', created_at: '10/30/2020', message: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
      ],
      messages: [
        {subject: 'Message 1', created_at: '10/30/2020', message: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
      ],
      is_showing_share_modal: false,
      share_data: {
        name: '',
        email: '',
        message: 'I\'ve shared my food profiles with you as you requested.\n\nThis will let you access and see what I\'ve been eating each day as well as access critical reports that will help you help me reach my dietary goals.',
        is_success: false,
      },
      is_showing_unshare_modal: false,
      unshare_data: {
        email: '',
        user_id:'',
        hash:''
      },
      is_showing_add_note_modal: false,
      add_note_data: {
        subject: '',
        note: '',
      },
      hidenotes:true,
      hidemessages:true,
      is_showing_upgrade_modal: false,
    };
  },
  computed: {
    is_free_user: function(){
      return this.$parent.user.type != 'individual';
    },
  },
  watch: {
    is_showing_share_modal: function(){
      if (this.$parent.user.type != 'individual') {
        this.is_showing_upgrade_modal = true;
        this.is_showing_share_modal = false;
      }
    },
  },
  mounted(){
    this.load_shares();
    this.load_notes();
    this.load_messages();
  },
  methods: {
    async submit_share_modal() {
      if (this.share_data.name == '') {
        alert('Please fill out a name.');
        return false;
      } else if (this.share_data.email == '') {
        alert('Please fill out an email.');
        return false;
      } else if (this.share_data.message == '') {
        alert('Please fill out a message.');
        return false;
      }

      let newshare = await this.$http('/api/share-portal/reports/createshare',{
        method:"post",
        headers: {
          'Content-type': 'application/json',
        },
        body:JSON.stringify({
          'name':this.share_data.name,
          'email':this.share_data.email,
          'message':this.share_data.message
        })
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });
      this.share_data= {
        name: '',
        email: '',
        message: 'Please keep my information private and confidential.',
        is_success: true,
      }
      this.load_shares();
    },
    show_share_modal() {
      var obj_multi = document.querySelectorAll('.container');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          ele.classList.add('dialog-no-print');
        }
      }
      this.is_success = false;
      this.is_showing_share_modal = true;

    },
    hide_share_modal() {
      var obj_multi = document.querySelectorAll('.dialog-no-print');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          ele.classList.remove('dialog-no-print');
        }
      }
      this.is_showing_share_modal = false;
    },

    async submit_unshare_modal() {
      let revokeshare = await this.$http('/api/share-portal/reports/revoke',{
        method:"post",
        headers: {
          'Content-type': 'application/json',
        },
        body:JSON.stringify({
          'userId':this.unshare_data.user_id,
          'hash':this.unshare_data.hash
        })
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });
      this.unshare_data={
        email: '',
        user_id:'',
        hash:''
      }
      this.load_shares();
      this.is_showing_unshare_modal = false;
    },
    show_unshare_modal(index) {
      this.unshare_data.email = this.shares[index].email;
      this.unshare_data.user_id = this.shares[index].user_id;
      this.unshare_data.hash = this.shares[index].hash;
      this.is_showing_unshare_modal = true;
    },
    hide_unshare_modal() {
      this.is_showing_unshare_modal = false;
    },

    async submit_add_note_modal() {
      this.is_showing_add_note_modal = false;
      let newshare = await this.$http('/api/share-portal/messagesshareduser',{
        method:"post",
        headers: {
          'Content-type': 'application/json',
        },
        body:JSON.stringify({
          'subject':this.add_note_data.subject,
          'message':this.add_note_data.note
        })
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });
      this.add_note_data= {
        subject: '',
        note: ''
      }
      this.load_notes();
    },
    show_add_note_modal(email) {
      this.add_note_data.subject = '';
      this.add_note_data.note = '';
      this.is_showing_add_note_modal = true;
    },
    hide_add_note_modal() {
      this.is_showing_add_note_modal = false;
    },
    async remove_note(id){
      if(confirm("Are you sure you want to remove this note?")){
        let removednote = await this.$http('/api/share-portal/messagesshareduser',{
          method:"delete",
          headers: {
            'Content-type': 'application/json',
          },
          body:JSON.stringify({
            'messages_shared_id':id
          })
        }).then(response => response.json())
          .then(async function(json) {
            if(json.message == "Unauthenticated."){
              throw new Error(JSON.stringify(json));
            }else{
              return json;
            }
          });
        this.load_notes();
      }
    },

    load_more_notes() {
      this.hidenotes=false;
    },
    load_more_messages() {
      this.hidemessages=false;
    },
    async load_shares(){
      let sharesdata = await this.$http('/api/share-portal/reports/getshares',{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });
      console.log(sharesdata);
      this.shares = sharesdata;

    },
    async load_notes(){
      let notesdata = await this.$http('/api/share-portal/messagesshareduser',{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });
      console.log(notesdata);
      this.notes = notesdata;

    },
    async load_messages(){
      let messagesdata = await this.$http('/api/share-portal/messagessite',{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });
      console.log(messagesdata);
      this.messages = messagesdata;

    }

  },
};
</script>

<style lang="scss" scoped>
	.content-box .button{float:right; font-size:12px; padding:4px 8px;}
</style>
